/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as e from "react";
import t from "prop-types";
import { classNames as m } from "@progress/kendo-react-common";
const c = e.forwardRef(
  (n, l) => {
    const o = e.useRef(null), r = e.useRef(null), { alignment: a = s.alignment, orientation: i = s.orientation } = n;
    return e.useImperativeHandle(r, () => ({ props: n, element: o.current })), e.useImperativeHandle(
      l,
      () => r.current
    ), /* @__PURE__ */ e.createElement(
      "div",
      {
        ref: o,
        className: m("k-popover-actions", "k-actions", {
          [`k-actions-${a}`]: a,
          [`k-actions-${i}`]: i
        })
      },
      n.children
    );
  }
), s = {
  alignment: "stretched",
  orientation: "horizontal"
};
c.propTypes = {
  alignment: t.oneOf(["start", "center", "end", "stretched"]),
  orientation: t.oneOf(["horizontal", "vertical"]),
  children: t.oneOfType([t.element, t.node])
};
c.displayName = "KendoReactPopoverActionsBar";
export {
  c as PopoverActionsBar
};
